import script from "./SendSmsComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./SendSmsComponents.vue?vue&type=script&setup=true&lang=js"

import "./SendSmsComponents.vue?vue&type=style&index=0&id=3e1072fe&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1072fe"]])

export default __exports__